import * as React from "react";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import { Typography } from "@mui/material";

function valuetext(value, unit) {
  return `${value}${unit}`;
}

export default function FilterSize({ min, max, title, unit, value, onChange }) {
  const handleChange = (event, newValue) => {
    onChange && onChange(newValue);
  };

  return (
    <Box sx={{ width: 300 }}>
      <Typography id="range-slider" gutterBottom>
        {title}
      </Typography>
      {/* subtitle showing the value */}
      <Typography variant="subtitle2" gutterBottom>
        {`${value[0]}${unit} - ${value[1]}${unit}`}
      </Typography>
      <Slider
        getAriaLabel={() => `${title} range`}
        value={value}
        onChange={handleChange}
        valueLabelDisplay="auto"
        getAriaValueText={(value) => valuetext(value, unit)}
        min={min}
        max={max}
      />
    </Box>
  );
}
